import {toDateMoment} from '../../../../../utility/dateUtil';

// Two medical events are the same event when they have the same type, event, day and time seen (AD-2717).
export const sameMedicalEventKey = (left, right) => {
    const sameDate = left.eventDate === right.eventDate ||
        Boolean(left.eventDate && right.eventDate &&
            toDateMoment(left.eventDate)?.isSame(toDateMoment(right.eventDate), 'day'));

    return left.eventTypeId === right.eventTypeId &&
        left.eventId === right.eventId &&
        sameDate &&
        (left.timeSeen || '') === (right.timeSeen || '');
};

// AD-2818: the duplicate check runs for a new event, or when an event's type, event, day or time seen changes.
// Adding a document or a summary to an event that has an identical copy is not a new duplicate.
export const needsDuplicateCheck = (stored, updated) => !stored || !sameMedicalEventKey(stored, updated);
